import { render, staticRenderFns } from "./BlockLevelStyleEditor.vue?vue&type=template&id=e1db1632&scoped=true&"
import script from "./BlockLevelStyleEditor.vue?vue&type=script&lang=js&"
export * from "./BlockLevelStyleEditor.vue?vue&type=script&lang=js&"
import style0 from "./BlockLevelStyleEditor.vue?vue&type=style&index=0&id=e1db1632&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1db1632",
  null
  
)

export default component.exports